// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__17ZhB","location":"Header_location__2m7Jt"};